// extracted by mini-css-extract-plugin
export var alignCenter = "_as-d";
export var bannerShown = "_as-6";
export var buttonContent = "_as-0";
export var cardList = "_as-1";
export var centerContent = "_as-2";
export var chevron = "_as-3";
export var closePanelButton = "_as-k";
export var conversationContextContainer = "_as-l";
export var conversationDetailContainer = "_as-4";
export var detailWrapper = "_as-7";
export var dropdownButton = "_as-e";
export var dropdownTitle = "_as-9";
export var fullHeight = "_as-5";
export var hidden = "_as-a";
export var icon = "_as-b";
export var mergeSuggestionWrapper = "_as-m";
export var panel = "_as-i";
export var portalButtonsWrapper = "_as-c";
export var right = "_as-j";
export var tableSummaryContainer = "_as-8";
export var tableSummaryHeader = "_as-g";
export var threeDotsButton = "_as-f";
export var wide = "_as-h";